import { render, staticRenderFns } from "./Adverts.vue?vue&type=template&id=c40efba4&scoped=true&"
import script from "./Adverts.vue?vue&type=script&lang=js&"
export * from "./Adverts.vue?vue&type=script&lang=js&"
import style0 from "./Adverts.vue?vue&type=style&index=0&id=c40efba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40efba4",
  null
  
)

export default component.exports